import {
  CommonDialogLayout,
  Dialog,
  LeaveGameDialogHead,
} from '@wwe-portal/ui/components/dialog';
import { useTranslations } from 'next-intl';
import { useNavigationGuard } from 'next-navigation-guard';
import { Button } from '../../../../../../packages/ui/components/button';
import { FC } from 'react';
import { usePathname } from 'next/navigation';

export const LeavingPageDialog: FC<{
  isPending: boolean;
  onAccept?: () => void;
  onReject?: () => void;
}> = ({ isPending, onAccept, onReject }) => {
  const pathname = usePathname();
  const navGuard = useNavigationGuard({
    enabled: (params) => {
      return isPending && params.to !== pathname;
    },
  });
  const t = useTranslations();
  const handleAccept = () => {
    onAccept?.();
    navGuard.accept();
  };
  const handleReject = () => {
    onReject?.();
    navGuard.reject();
  };
  return (
    <Dialog open={navGuard.active}>
      <CommonDialogLayout
        imageElement={<LeaveGameDialogHead />}
        titleElement={t('notice')}
        descriptionElement={
          <span className="text-base">{t('are_you_sure')}</span>
        }
        onClose={navGuard.reject}
        actionElement={
          <div className="flex gap-5">
            <Button
              onClick={handleAccept}
              variant="secondary"
              size="large"
              className="bg-borderColor1 hover:text-inlineTextColor6 text-text500 min-h-[50px] min-w-[110px] text-sm font-light uppercase"
            >
              {t('quit')}
            </Button>
            <Button
              variant="blue"
              size="large"
              onClick={handleReject}
              className="min-h-[50px] w-[110px] text-sm font-light uppercase"
            >
              {t('cancel')}
            </Button>
          </div>
        }
        closable={true}
        dataId={''}
      />
    </Dialog>
  );
};
